import type { IconWeight } from "@phosphor-icons/react";

/**
 * Phosphor has no opsz/GRAD. CDS paints 10–16px where Material compensates
 * with GRADE. Bold is the analog at those sizes so stroke survives the box.
 * Stay bold through 20px (Material's opsz floor) so 16→20 doesn't drop weight.
 * `filled` is still semantic (on / selected / presence), mapped to `fill`.
 */
export function phosphorWeight(cssPx: number, filled = false): IconWeight {
  if (filled) return "fill";
  return cssPx <= 20 ? "bold" : "regular";
}
